import { useState } from "react";
import { Home, BatteryCharging, UtilityPole } from "lucide-react";
import { pw } from "./clienteApi";
import { SlotDialogs } from "./SlotDialogs";

export function Tiles({ imp, big, src }) {
  const f = imp.flussi || {}, bw = f.batteria_w || 0, gw = f.rete_w || 0, c = imp.consumi_disponibili && f.casa_w != null;
  const [slot, setSlot] = useState(null);
  const bt = imp.temperatura_batteria;
  const bstat = (bw > 20 ? "in scarica" : bw < -20 ? "in carica" : "a riposo") + (bt != null ? ` · ${Math.round(bt)}°C` : "");
  const rows = [
    imp.ha_batteria && [BatteryCharging, "Batteria", `${f.soc ?? imp.soc ?? "—"}%`, bstat, "#10B981", "tile-batteria", "batteria"],
    [Home, imp.tipo === "azienda" ? "Azienda" : "Casa", c ? pw(f.casa_w) : "—", c ? "consumo adesso" : "consumi in verifica", "#3B82F6", "tile-casa", c ? "casa" : null],
    c && [UtilityPole, "Rete", pw(gw), gw < -20 ? "stai vendendo" : gw > 20 ? "stai prelevando" : "ferma", "#64748B", "tile-rete", "rete"],
  ].filter(Boolean);
  return (
    <>
      <div className="grid gap-2.5" style={{ gridTemplateColumns: `repeat(${rows.length},minmax(0,1fr))` }}>
        {rows.map(([I, l, v, s, col, id, kind]) => {
          const clic = src && kind;
          const Tag = clic ? "button" : "div";
          return (
            <Tag key={l} type={clic ? "button" : undefined} onClick={clic ? () => setSlot(kind) : undefined}
              className={`rounded-3xl bg-white p-3 text-center shadow-sm ring-1 ring-slate-100 ${clic ? "transition-transform hover:scale-[1.03] active:scale-95" : ""}`} data-testid={id}>
              <span className="mx-auto flex h-10 w-10 items-center justify-center rounded-2xl" style={{ background: `${col}1A` }}><I className="h-5 w-5" style={{ color: col }} /></span>
              <b className={`mt-1.5 block text-slate-800 ${big ? "text-3xl" : "text-lg"}`}>{v}</b><span className="text-[11px] font-semibold text-slate-500">{l} · {s}</span>
            </Tag>
          );
        })}
      </div>
      <SlotDialogs slot={slot} onClose={() => setSlot(null)} src={src} soh={imp.salute_batteria} temp={imp.temperatura_batteria} pro={imp.pro} />
    </>
  );
}
